import { combineReducers } from 'redux';
import quickStart from './quick-start';

export const quickStartReducers = combineReducers({
  quickStart,
});
